import prism from "./prism"

const colors = {
  prism,

  blue: "rgb(58, 178, 230)",
  yellow: "rgb(255, 215, 94)",
  red: "rgb(240, 90, 101)",
  accent: "rgb(58, 178, 230)",
  articleText: "#08080B",
  background: "rgb(255,255,255)",
  backgroundGradient: "rgba(251,,250,, 211, .3)",
  blackLight: "rgb(255, 222, 1)",
  border: "rgba(0, 0, 0, 0.08)",
  card: "#fff",
  gradient: "linear-gradient(180deg, rgba(217, 219, 224, 0) 0%, #D9DBE0 100%)",
  gray: "#C0C0C0",
  header: "rgb(24,39,54)",
  heading: "rgb(27,27,27)",
  hover: "rgba(0, 0, 0, 0.07)",
  horizontalRule: "rgba(8, 8, 11, 0.3)",
  paragraph: "#536171",
  progress: "#fff",
  primary: "rgb(255, 222, 1)",
  icon: "#ffde01",
  secondary: "rgb(255,246,209)",
  title: "rgb(37, 53, 69)",
  white: "rgb(255,255,255)",
}

export default colors
